import Flickity from 'flickity';
import 'flickity-bg-lazyload';
import 'flickity-fade';
import 'flickity-imagesloaded';

document.addEventListener( 'DOMContentLoaded', function () {
	const flickityContainers = document.querySelectorAll(
		'.flickity-container'
	);

	flickityContainers.forEach( ( container ) => {
		new Flickity( container, {
			cellAlign: 'left',
			contain: true,
			prevNextButtons: false,
			imagesLoaded: true,
			pageDots: false,
			autoPlay: 5000,
			fade: true,
			setGallerySize: false,
			bgLazyLoad: true,
		} );
	} );
} );
